<template>
    <WaitingBlock v-if="$store.state.loadingStates.isLoadingBox"/>
    <Filters v-else-if="box && box.trackFilters" type="box" :addDefault="true" :filters="box.trackFilters"
             :filteredBoxes="box.filteredBoxes" v-on:save="save"/>
    <div v-else>
        No filters for this box
    </div>
</template>


<script>
    // Components
    import Filters from '../common/Filters.vue';
    import WaitingBlock from '../common/WaitingBlock.vue';

    export default {
        components: {
            Filters,
            WaitingBlock
        },
        computed: {
            box() {
                return this.$store.state.currentBox;
            }
        },
        methods: {
            async save(filters) {
                const response = await this.$store.dispatch('updateBoxFilters', filters);
                const isValid = response.status === 200;
                const ok = 'Smart box filters successfully saved';
                const nok = 'Problem occured when saving smart box filters';

                await this.$store.dispatch('Toasts/addToast', {
                    title: `${isValid ? 'Success' : 'Error' }`,
                    message: `${isValid ? ok : nok}`,
                    type: `${isValid ? 'success' : 'danger'}`
                })
            }
        }
    }
</script>
